import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as authActions,
} from '../../../../redux/modules/auth';
import {
  actions as mainActions,
} from '../../../../redux/modules/main';

import ProfileHeaderSectionView from './ProfileHeaderSectionView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './ProfileHeaderSectionView';

const mapStateToProps = (): $StateProps => Object.freeze({
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  setActiveRegattaId: (params) => dispatchAction(
    mainActions.setActiveRegattaId(params),
  ),
  unauthenticate: () => dispatchAction(
    authActions.unauthenticate(),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileHeaderSectionView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
